import { render, staticRenderFns } from "./WidgetSimple.vue?vue&type=template&id=5e6bef56"
import script from "./WidgetSimple.vue?vue&type=script&lang=js"
export * from "./WidgetSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports